var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-title", {
        attrs: {
          title: "Ihre kürzlich geschlossenen Supportanfragen",
          subtitle:
            "Diese Seite zeigt Ihre Support-Vorgänge, die in den letzten 65 Tagen geschlossen wurden."
        }
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize",
              value: _vm.onResize,
              expression: "onResize"
            }
          ],
          staticClass: "data-table-layout",
          attrs: { column: "" }
        },
        [
          _c("close-cases-table", {
            attrs: { "case-data": _vm.data },
            on: {
              getAllCloseCases: _vm.getAllCloseCases,
              expandAttendanceCloseCase: _vm.expandAttendanceCloseCase
            }
          }),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "right-button-container",
                  attrs: { id: "right", xs12: "", md12: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { id: "form-button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.goTo()
                        }
                      }
                    },
                    [_vm._v("Zurück")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }